define('invite-component/invite-component-container',['require','knockout','web-urls','plugins/dialog','dialog-helper/responsive','durandal/app','i18next','tealium-utils'],function (require) {
    var ko = require('knockout');
    var webUrls = require('web-urls');
    var dialog = require('plugins/dialog');
    var responsiveDialog = require('dialog-helper/responsive');
    var app = require('durandal/app');
    var i18n = require('i18next');
    var tealiumUtils = require('tealium-utils');

    var Invite = function (meetingId, showPhoneNumberUpdatedBanner) {
        var self = this;
        self.showModal = ko.observable(true);
        self.showSpinner = ko.observable(true);

        self.iframeUrl = webUrls.get('baseUrl') + '/public/invite-component/latest/index.html?' +
            'communicator-strategy=post-message&' +
            'communicator-id=invite-component&' +
            'show-skip-action=true&' +
            'lng=' + i18n.lng() + '&' +
            'show-phone-number-updated-banner=' + !!showPhoneNumberUpdatedBanner + '&' +
            'show-close-action=true';

        if (meetingId) {
            self.iframeUrl = self.iframeUrl + '&meeting-id=' + meetingId;
        }

        /*
         * var centerHeight = function (element) {
         *     element.style.marginTop = -1 * parseFloat(element.style.height) / 2 + 'px';
         * };
         */

        function handleMessage(event) {
            if (event.data && typeof event.data === 'string') {
                var data = JSON.parse(event.data);

                var messages = {
                    cancel: function () {
                        self.close();
                    },

                    dimensions: function () {
                        var inviteElement = document.querySelector('.invite-component-iframe');

                        if (self.showSpinner()) {
                            self.showSpinner(false);
                        }

                        if (inviteElement) {
                            inviteElement.style.height = data.data.height + 'px';

                            // Trigger resize to center modal
                            var modalElement = document.getElementById('invite-component-container');
                            modalElement.style.height = ''; // Needs to be cleared, for scroll to work.
                            dialog.getContext().reposition(modalElement);

                            self.showModal(true);
                            app.trigger('inviteModal:shown');
                        }
                    },

                    clickedTextAction: function () {
                        app.trigger('inviteModal:clickedTextAction');
                    }
                };

                if (data.id === 'invite-component' && messages[data.message]) {
                    messages[data.message]();
                }
            }
        }

        self.close = function () {
            dialog.close(self);
            window.removeEventListener('message', handleMessage);
        };

        self.activate = function () {
            window.addEventListener('message', handleMessage);
        };

        self.compositionComplete = function (child) {
            responsiveDialog(self, child);
        };
    };

    Invite.show = function (meetingId, showPhoneNumberUpdatedBanner) {
        window.mixpanel.track('Open Share Meeting Modal');
        tealiumUtils.sendTealiumEvent('meetings', 'share-meeting');
        return dialog.show(new Invite(meetingId, showPhoneNumberUpdatedBanner));
    };

    return Invite;
});

